import { render, staticRenderFns } from "./BlmSourceDetail.vue?vue&type=template&id=70be0765&scoped=true"
import script from "./BlmSourceDetail.vue?vue&type=script&lang=js"
export * from "./BlmSourceDetail.vue?vue&type=script&lang=js"
import style0 from "./BlmSourceDetail.vue?vue&type=style&index=0&id=70be0765&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70be0765",
  null
  
)

export default component.exports